import React from 'react';
import '../../assets/css/elements/search-bar.css';

const SearchBar = ({ searchQuery, onSearchChange }) => {
    return (
        <div className="search-bar">
            <input
                type="text"
                placeholder="Search products..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="search-input"
            />
            <span className="search-icon">🔍</span>
        </div>
    );
};

export default SearchBar;
